import { takeEvery } from 'redux-saga'
import { put, call, fork } from 'redux-saga/effects'
import { applyProjectsAction, expandProjectAction } from 'actions/projectActions'
import { SETUP_PROJECTS } from 'actions/applicationActionTypes'
import { startAutosaveSagaAction } from 'actions/applicationActions'
import catchEarlyErrorsSaga from 'sagas/catchEarlyErrorsSaga'
import { getAndApplyCameraData } from 'sagas/getAndApplyCameraDataSaga'
import getLegacyProjectsSaga from 'sagas/getLegacyProjectsSaga'
import isEmpty from 'ramda/src/isEmpty'
import complement from 'ramda/src/complement'
import handleProjectsAndSettings from 'sagas/setupProjectsSaga/handleProjectsAndSettings'
import applyProjectsWhenPeramlink from 'sagas/setupProjectsSaga/applyProjectsWhenPeramlink'
import handleOfflineProject from 'sagas/setupProjectsSaga/handleOfflineProject'
import handleManufacturerSpecificSetup from 'sagas/setupProjectsSaga/handleManufacturerSpecificSetup'
import retrieveDataFromUrl from 'sagas/setupProjectsSaga/retrieveDataFromUrl'
import configDatabase from 'sagas/setupProjectsSaga/configDatabase'
import ensureAppIntegrity from 'sagas/setupProjectsSaga/ensureAppIntegrity'
import offlineTimerSaga from 'sagas/offlineTimerSaga'

/*
This saga handles the various ways the calculator is setup:

- Signed in
- Signed in + permalink
- Signed in + camera model chosen
- Signed in + project brought over from being offline
- Offline
- Offline + permalink
- Offline + camera model chosen
- Offline + manufacturer path

*/

export function * setupProjects(action) {
  try {
    const { offline, active, offlineProject, cameraDataFilename } = action
    // get camera data
    yield call(getAndApplyCameraData, cameraDataFilename)
    // create database config
    if (!offline) {
      const db = yield call(configDatabase)
      yield call(ensureAppIntegrity, db)
    }
    // get model info from param
    const { model, permalinkProject, manufacturer } = yield call(retrieveDataFromUrl)

    if (manufacturer) yield handleManufacturerSpecificSetup({ offline, active, manufacturer })
    // if permalink
    else if (permalinkProject !== null && complement(isEmpty)(permalinkProject)) {
      // if offline, apply it as a single project
      if (offline) yield put(applyProjectsAction([permalinkProject]))
      // if signed in, grab all projects and apply them
      else yield call(applyProjectsWhenPeramlink)
      // expand project
      yield put(expandProjectAction(permalinkProject, offline, active, true))
    // if no permalink and offline and an offlineProject is present
    // (offline w/manufacturer -> reset specific manufacturer and restart app)
    } else if (offline && offlineProject) yield put(expandProjectAction(offlineProject, offline, active, false))
    // if no permalink and offline, start calculator in offline mode
    else if (offline) yield call(handleOfflineProject, { model, active })
    // if signed in
    else {
      // retrieve the current project and settings
      const { project, settings } = yield call(handleProjectsAndSettings, offlineProject, model)
      // apply as a single project
      yield put(applyProjectsAction([project]))
      // expand project
      yield put(expandProjectAction(project, false, true, false, settings))
    }

    if (!permalinkProject && !EXPORT) {
      if (!offline) {
        yield put(startAutosaveSagaAction())
        yield fork(getLegacyProjectsSaga)
      } else {
        yield fork(offlineTimerSaga)
      }
    }
  } catch (err) {
    if (!action.offline) yield call(catchEarlyErrorsSaga, err)
  }
}

export function * watchSetupProjects() {
  yield * takeEvery(SETUP_PROJECTS, setupProjects)
}



// WEBPACK FOOTER //
// ./src/sagas/setupProjectsSaga/index.js